export default __webpack_public_path__ + "static/bg-ensino-fundamental-8545fd713804fd9aae06bb2c752785c4.svg";